
import Vue, { watch } from 'vue';

import * as RootStore from '@/store/search/';
import * as GlobalViewSettings from '@/store/search/results/global';
import * as ResultsViewSettings from '@/store/search/results/views';

import SelectPicker,{ Option } from '@/components/SelectPicker.vue';
import Modal from '@/components/Modal.vue';

import debug from '@/utils/debug';
import { localStorageSynced } from '@/utils/localstore';

// outside component, want to always run this code, even when component is invisible.
export const wideView = localStorageSynced('cf/wideView', false);
watch(() => wideView.value, v => document.querySelectorAll('.container, .container-fluid').forEach(el => {
	el.classList.toggle('container', !v);
	el.classList.toggle('container-fluid', !!v);
}), {immediate: true});

export default Vue.extend({
	components: {
		SelectPicker,
		Modal
	},
	data: () => ({
		debug,
		wideView,
	}),
	computed: {
		viewedResultsSettings: RootStore.get.viewedResultsSettings,
		pageSize: {
			get(): string { return this.itoa(GlobalViewSettings.getState().pageSize); },
			set(v: string) {
				try {
					const i = this.atoi(v)!;
					GlobalViewSettings.actions.pageSize(i);
				} catch (e) {
					// ignore invalid input
					this.pageSize = "20";
				}
			}
		},
		sampleMode: {
			get() { return GlobalViewSettings.getState().sampleMode; },
			set(v: GlobalViewSettings.ModuleRootState['sampleMode']) {
				GlobalViewSettings.actions.sampleMode(v);
				ResultsViewSettings.actions.resetFirst();
			}
		},
		sampleModeOptions(): Option[] {
			return [{
				value: 'percentage',
				label: this.$t('setting.sampleSizePercentage').toString(),
			}, {
				value: 'count',
				label: this.$t('setting.sampleSizeCount').toString(),
			}]
		},
		sampleSize: {
			get(): string { return this.itoa(GlobalViewSettings.getState().sampleSize); },
			set(v: string) {
				GlobalViewSettings.actions.sampleSize(this.atoi(v));
				ResultsViewSettings.actions.resetFirst();
			}
		},
		sampleSeed: {
			get(): string { return this.itoa(GlobalViewSettings.getState().sampleSeed); },
			set(v: string) {
				GlobalViewSettings.actions.sampleSeed(this.atoi(v));
				if (this.viewedResultsSettings && this.viewedResultsSettings.groupBy.length) {
					// No need to do this when ungrouped - the raw number of results
					// will stay as it is, but the distribution (and number of) groups may change and
					// cause the number of pages to shift
					ResultsViewSettings.actions.resetFirst();
				}
			}
		},
		context: {
			// context can be a string or number in BlackLab, but for now in the form we only allow numbers.
			// hence the atoi so BlackLab receives a number
			// the .value interface of html input field only deals in strings...
			get(): string {
				const c = GlobalViewSettings.getState().context;
				return c != null ? c.toString() : '';
			},
			set(v: string) { GlobalViewSettings.actions.context(this.atoi(v)); }
		},
	},
	methods: {
		focusSampleSize() {
			(this.$refs.sampleSize as HTMLInputElement).focus()
		},
		itoa(n: number|null): string { return n == null ? '' : n.toString(); },
		atoi(s: string): number|null { return s ? Number.parseInt(s, 10) : null; }
	},
})
